var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "snackbar vModal",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _vm._t("icon", function () {
        return [_vm._m(0)]
      }),
      _vm._t("body", function () {
        return [_c("div", { staticClass: "snackbar-body" })]
      }),
      _vm._t("actions", function () {
        return [
          _c("div", { staticClass: "snackbar-buttons" }, [
            _c(
              "button",
              {
                staticClass: "snackbar-button",
                attrs: { type: "button" },
                on: { click: _vm.cancel },
              },
              [_vm._v("CLOSE")]
            ),
          ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "snackbar-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info_outline")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }